<template>
     <v-sheet :style="styles" color="bgtl" class="statusCards timelineStyles text-left" :height="heigth">
        <v-row class="ma-0" :style="`height: ${heigth}px !important;`">
            <div class="d-flex flex-column justify-space-between" style="height: 100%; width: 100%;">
                <v-row class="ma-0" justify="space-between">
                    <v-col class="pa-0" cols="4">
                        <v-sheet :height="isTopology ? 80 : 60" :width="isTopology ? 80 : 60" class="cardIcon text-center">
                            <svg v-if="isTopology" class="iconMAP pt-1" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                width="68px" viewBox="0 0 300 300" >
                                <g v-html="finalImage"/>
                            </svg>
                            <v-icon v-else class="iconStyle" :icon="icon" size="40" ></v-icon>
                        </v-sheet>
                    </v-col>

                    <v-col class="pa-0" cols="8">
                        <p  class="cardRight mt-4"> <span class="card-category">{{ t('labels.equipment') }}<span v-if="!isTopology">s</span>  </span> </p> 
                        <p class="cardRight"> <span :class="isTopology ? 'cardTitleTopology' :'card-title'">{{ middleText }}</span> </p> 
                    </v-col>
                </v-row>
                <v-sheet color="transparent">
                    <v-col cols="12" class='pa-0 pt-4 pb-1'>
                        <v-divider thickness="2" class="mx-1"></v-divider>
                    </v-col>

                    <v-col class='pa-1 pb-3'>
                        <p class="cardBottomTopology ml-4"> <span> {{bottomText}} </span> </p>     
                    </v-col>
                </v-sheet>                
            </div>
        </v-row>
    </v-sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n()

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTANTIMGS from '@/constants/images';
import CONSTANTSVGS from '@/constants/svg';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { IMGS } from '@/interfaces/SmartLink/Imgs';


const props = defineProps({
    icon        : { type: String, required: false },
    colorIcon   : { type: String, required: true },
    middleText  : { type: String, required: true },
    bottomText  : { type: String, required: true },
    isTopology  : { type: Boolean, default: false },
    typeItem    : { type: String, default: 'Camion' },
    heigth      : { type: Number, default: 180 },
})

const CONST_IMG:IMGS = {
    "PMP-AP"            : CONSTANTSVGS.pmpap,
    "PMP-SM"            : CONSTANTSVGS.pmpsm,
    "AP Movil"          : CONSTANTSVGS.solarTrailer,
    "AP FIjo"           : CONSTANTSVGS.tower,
    "Pala"              : CONSTANTSVGS.showel,
    "Camion"            : CONSTANTSVGS.haultruck,
    "Perforadora"       : CONSTANTSVGS.driller,
    "Cargador Frontal"  : CONSTANTSVGS.frontLoader,
    "Pila Agua"         : CONSTANTSVGS.waterTruck,
    "LTE"               : CONSTANTIMGS.IMAGES.lte,
    "PTP"               : CONSTANTSVGS.ptp,
};

const finalImage    = computed( () => CONST_IMG[props.typeItem]);

const styles = computed(() => {
    return { 
        '--colorIcon': props.colorIcon ,
        '--colorTextIcon' : props.colorIcon === COLOR.yellow ? '#000000' : '#FFFFFF'
    }
})
</script>

<style>
.statusCards .card-title {
    color: rgb(var(--v-theme-colorText));
    text-transform: capitalize;
    font-weight: 300;
    font-size: 40px;
}

.statusCards .cardTitleTopology {
    color: rgb(var(--v-theme-colorText));
    text-transform: capitalize;
    font-weight: 200;
    font-size: 1.5rem;
}
.statusCards .cardBottomTopology {
    color: rgb(var(--v-theme-colorText));
    text-transform: capitalize;
    font-weight: 200;
    font-size: 18px;
}
.statusCards .card-category {
    margin-bottom: 0;
    margin-top: 20px;
    color: #9a9a9a;
    font-size: 15px;
}
.cardIcon{
    border-radius: 50%;
    color: var(--colorTextIcon);
    background-color: var(--colorIcon);
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.iconStyle{
    margin: 10px;
}
.statusCards .cardRight{
    margin-right: 16px;
    text-align: right;
}
</style>